
define('template!sdsMenuMdSidenav',['directive!sdcLoading','directive!sdsMenuMdSidenavItems'],function(template){return '<md-content sdc-loading="vm.loading">\r\n\t<sds-menu-md-sidenav-items menu-items="vm.menu.MenuItemList" ng-if="vm.menu.MenuItemList.length" selected="vm.selected" attrs="vm.attrs" root-name="vm.menu.Name"></sds-menu-md-sidenav-items>\r\n</md-content>';});

